<template>
	<div>
		<div class="data31">
			<div class="data31Til">{{list.data.menuTitle}}</div>
			<div class="data31Cen" v-if="list.data.desc.length>0">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div class="data31Box">
				<div class="swiper-hexinTwo" :class="`swiper-hexinTwo${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide data31BoxList" v-for="(item,index) in list.data.content" :key="index">
							<!-- <div class="data31BoxList" -->
							<div class="data31BoxListImg">
								<img :src="item.cover" />
							</div>
							<div class="data31BoxListImgTwo">
								<img :src="item.icon" />
							</div>
							<div class="data31BoxListWz">
								<div class="data31BoxListWzName">
									{{item.title}}
								</div>
								<div class="data31BoxListWzCen">
									<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
								</div>
							</div>
							<!-- </div> -->
						</div>

					</div>
					
					<div class="swiper-hexin-prev" v-if="list.data.content.length>0">
						<img src="@/assets/product/page6/zjt.png" />
					</div>
					<div class="swiper-hexin-next" v-if="list.data.content.length>0">
						<img src="@/assets/product/page6/yjt.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list:[
				// 	{
				// 		img:require('@/assets/product/page8/ledgy.png'),
				// 		imgTwo:require('@/assets/product/page11/dgcsj.png'),
				// 		name:'大视场角',
				// 		cen:'- 140°大视场角- 减少信息遗漏'
				// 	},
				// 	{
				// 		img:require('@/assets/product/page8/ledgy.png'),
				// 		imgTwo:require('@/assets/product/page11/dqd.png'),
				// 		name:'大钳道',
				// 		cen:'- 结肠镜钳道3.7mm- 可匹配绝大多数手术耗材'
				// 	},
				// ]
			}
		},
		mounted() {
			let t = this
			let name = '.swiper-hexinTwo' + this.list.index;
			if (this.headerShow) {
				const mySwiper = new this.$swiper(name, {
					// 方向
					direction: 'horizontal',
					// 自动播放
					autoplay: false,
					widch: 580,
					// freeMode: true,
					slidesPerView: 'auto',
					navigation: {
						prevEl: ".swiper-hexin-prev",
						nextEl: ".swiper-hexin-next",
					},
					allowTouchMove: this.list.data.content.length > 1 ? true : false,
					// slidesPerView: 1,
					on: {
						slideChangeTransitionStart(e) {
							t.activeIndex = this.activeIndex;
						},

					},
				});
			} else {
				const mySwiper = new this.$swiper(name, {
					// 方向
					direction: 'horizontal',
					// 自动播放
					autoplay: false,
					// freeMode: true,
					slidesPerView: 'auto',
					navigation: {
						prevEl: ".swiper-hexin-prev",
						nextEl: ".swiper-hexin-next",
					},
					allowTouchMove: this.list.data.content.length > 1 ? true : false,
					// slidesPerView: 1,
					on: {
						slideChangeTransitionStart(e) {
							t.activeIndex = this.activeIndex;
						},

					},
				});
			}

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data31 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data31Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.data31Cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;
			white-space: pre-line;
		}

		.data31Box {
			display: flex;
			justify-content: space-between;

			.data31BoxList:not(:last-child) {
				margin-right: 40px;
			}

			.data31BoxList:hover {
				.data31BoxListImg {
					img {
						// transform: scale(1.1);
					}
				}
			}

			.data31BoxList {
				width: 580px;

				.data31BoxListImg {
					margin-bottom: 33px;
					width: 580px;
					height: 440px;
					overflow: hidden;
					margin-bottom: 40px;

					img {
						width: 580px;
						height: 440px;
						object-fit: cover;
						transition: all 0.3s ease-in-out;
					}
				}

				.data31BoxListImgTwo {
					margin-bottom: 32px;

					img {
						width: 70px;
						height: 70px;
						// object-fit: cover;
						transition: all 0.3s ease-in-out;
					}
				}

				.data31BoxListWz {
					.data31BoxListWzName {
						// margin-right: 20px;
						font-size: 26px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #000000;
						margin-bottom: 32px;
					}

					.data31BoxListWzCen {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #000000;
						white-space: pre-line;
					}
				}
			}
		}
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 220px;
			left: 30px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;
			cursor: pointer;
		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 220px;
			right: 30px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data31 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.data31Til {
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}

			.data31Cen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}

			.data31Box {
				.data31BoxList:not(:last-child) {
					margin-right: 20px !important;
				}

				.data31BoxList {
					width: 100% !important;

					.data31BoxListImg {
						margin-bottom: 20px !important;
						width: 100% !important;
						height: auto !important;
						margin-bottom: 20px !important;

						img {
							width: 100% !important;
							height: auto !important;
							object-fit: contain !important;
						}
					}

					.data31BoxListImgTwo {
						margin-bottom: 20px !important;

						img {
							width: 35px !important;
							height: 35px !important;
						}
					}

					.data31BoxListWz {
						.data31BoxListWzName {
							// margin-right: 20px;
							font-size: 18px !important;
							margin-bottom: 20px !important;
						}

						.data31BoxListWzCen {
							font-size: 14px !important;
						}
					}
				}
			}
		}
	}
</style>